'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import useShallowMemo from 'use-shallow-memo';
import FullstoryContext from '../contexts/fullstory.js';
import useFullstoryBrowser from '../hooks/use-fullstory-browser.js';
function useFullstoryEffects({ identityProperties, identityUid, ...snippetOptions }) {
    const { FullStory: fullstoryApi, init, isInitialized, } = useFullstoryBrowser();
    const memoizedSnippetOptions = useShallowMemo(snippetOptions);
    useEffect(() => {
        if (isInitialized()) {
            return;
        }
        init(memoizedSnippetOptions);
        return () => {
            fullstoryApi('shutdown');
        };
    }, [fullstoryApi, init, isInitialized, memoizedSnippetOptions]);
    useEffect(() => {
        if (typeof identityProperties === 'undefined' &&
            typeof identityUid === 'undefined') {
            fullstoryApi('setIdentity', {
                anonymous: true,
                consent: false,
            });
            return;
        }
        fullstoryApi('setIdentity', {
            anonymous: false,
            consent: false,
            properties: identityProperties,
            uid: identityUid,
        });
    }, [fullstoryApi, identityProperties, identityUid]);
}
export default function Fullstory({ children, ...props }) {
    const { FullStory: fullstoryApi } = useFullstoryBrowser();
    useFullstoryEffects(props);
    return (_jsx(FullstoryContext.Provider, { value: fullstoryApi, children: children }));
}
//# sourceMappingURL=fullstory.js.map